import { keyframes } from "styled-components";
import { startPositions } from "../components/organisms/OverlayContainerOrg";
export var slideOutHorizontal = function slideOutHorizontal(type) {
  return keyframes(["from{transform:none;}to{transform:translateX(", ");}"], type === startPositions.RIGHT ? "100vw" : "-100vw");
};
export var slideOutVertical = keyframes(["from{transform:none;}to{transform:translateY(100vh);}"]);